import React from 'react';
import '../../App.css';


export default function Services() {
         return <h1 class="services">SERVICES</h1>;
}